export enum TablesType {
  AccountView = "account-view",
  AccountDetails = "account-details",
  AccountSymbol = "account-symbol",
  Symbol = "symbol",
  Cabinet = "cabinet",
  PastTransactions = "past-transactions",
  ScenarioTransactions = "scenario-transactions",
  RedactionDraft = "redaction-draft",
  RedactionView = "redaction-view",
  EarnVersion = "earn-version",
  InstitutionDetails = "institution-details",
  Categories = "categories",
  Classifications = "classifications",
  Budget = "budget",
  BudgetHistory = "budget-history",
}
